import React, { Component } from "react";
import {
  Wrapper,
  CardBody,
  WistiaVideo,
  Title,
  Card,
  Copy,
  Bold,
  Row,
  Icon
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";
import Quote from "app/DealMachineCore/snippets/Quote";

import { loadDashboardStep, displayIntercom } from "app/NativeActions";
import SkipButton from "./SkipButton";
class CreateNumberStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      dashboard_step: null
    };

    this.completedStep = this.completedStep.bind(this);
  }

  componentDidMount() {
    loadDashboardStep("create_number")
      .then(data => {
        if (data && data.items) {
          if (data.items.length > 0) {
            this.setState({
              dashboard_step: data.items[0]
                ? data.items[0].fields
                  ? data.items[0].fields
                  : null
                : null,
              loading: false
            });
          }
        }
        this.setState(() => ({ loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ loading: false }));
      });
  }

  renderCopy(dashboard_step) {
    return (
      <Wrapper>
        <Copy style={{ flex: 1, textAlign: "center" }}>
          {dashboard_step.description}
        </Copy>
        <Copy style={{ flex: 1, textAlign: "center" }}>
          {dashboard_step.otherText}
        </Copy>
      </Wrapper>
    );
  }
  renderQuote(dashboard_step) {
    return (
      <Quote
        center={this.props.isMobile ? true : false}
        style={{ padding: 15, paddingTop: 5, maxWidth: 600 }}
        image={
          dashboard_step.quoteImage
            ? dashboard_step.quoteImage.fields.file.url
            : ""
        }
        title={dashboard_step.quoteText}
        description={dashboard_step.quoteDescription}
      />
    );
  }

  completedStep() {
    this.props.updateTab("saved_replies");
    this.props.updateDashboard({
      token: this.props.token,
      type: "message_step",
      current_step: "saved_replies"
    });
  }

  renderButtons(dashboard_step) {
    if (this.props.team_phone_number_groups.length > 0) {
      return (
        <Row>
          <PillButton primary={true} onPress={this.completedStep}>
            {dashboard_step.secondaryButtonText}
          </PillButton>
        </Row>
      );
    } else {
      return (
        <Row>
          <PillButton
            primary={true}
            onPress={() => {
              this.props.appRedirect({
                redirect: "goForward",
                payload: { add: "add-phone-number" }
              });
            }}
          >
            {dashboard_step.nextButtonText}
          </PillButton>
        </Row>
      );
    }
  }

  renderChecks(dashboard_step) {
    return (
      <Wrapper>
        {dashboard_step.contentItems &&
          dashboard_step.contentItems.map((item, index) => {
            return (
              <Wrapper key={"check_" + index}>
                <Row>
                  <Wrapper
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      width: 30,
                      height: 30
                    }}
                  >
                    <Icon
                      color={this.props.colors.success_color}
                      icon="check"
                      size={26}
                    />
                  </Wrapper>
                  <Wrapper style={{ padding: 10 }}>
                    <Copy>
                      <Bold>{item.fields.title}</Bold>
                    </Copy>
                    <Copy>{item.fields.description}</Copy>
                  </Wrapper>
                </Row>
              </Wrapper>
            );
          })}
      </Wrapper>
    );
  }

  render() {
    const { loading, dashboard_step } = this.state;
    if (this.props.active_tab == "create_number") {
      if (!loading && dashboard_step) {
        return (
          <Wrapper>
            <CardBody>
              <Row
                style={{
                  flexDirection: this.props.isMobile ? "column" : "row",
                  alignItems: "flex-start"
                }}
              >
                <Wrapper
                  style={{
                    paddingTop: 20,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Wrapper style={{ paddingBottom: 20 }}>
                    <Title>{dashboard_step.header}</Title>
                    {this.renderChecks(dashboard_step)}
                  </Wrapper>

                  {this.renderButtons(dashboard_step)}
                </Wrapper>

                <Wrapper
                  style={{
                    padding: 20,
                    maxWidth: this.props.isMobile ? "100%" : 200,
                    alignItems: "flex-start",
                    justifyContent: "flex-start"
                  }}
                >
                  <Copy style={{ fontSize: 12 }}>DID YOU KNOW</Copy>
                  <Copy
                    style={{
                      fontSize: 20,
                      lineHeight: this.props.device == "desktop" ? "25px" : 25
                    }}
                  >
                    <Bold>{dashboard_step.quoteText}</Bold>
                  </Copy>
                  <Copy style={{ fontSize: 12 }}>
                    {dashboard_step.quoteDescription}
                  </Copy>
                </Wrapper>
              </Row>
            </CardBody>
          </Wrapper>
        );
      }
    }
    return <Wrapper />;
  }
}

export default CreateNumberStep;
